var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1616_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6 4.84741V13.3998C19.6 14.1955 19.284 14.9585 18.7213 15.5211C18.1587 16.0837 17.3957 16.3998 16.6 16.3998H3.40002C2.60438 16.3998 1.84131 16.0837 1.2787 15.5211C0.716095 14.9585 0.400024 14.1955 0.400024 13.3998V4.84741L9.69523 10.317C9.78757 10.3715 9.89282 10.4002 10 10.4002C10.1072 10.4002 10.2125 10.3715 10.3048 10.317L19.6 4.84741ZM16.6 0.799805C17.3382 0.799689 18.0505 1.07173 18.6007 1.56389C19.1508 2.05605 19.5002 2.73377 19.582 3.4674L10 9.10381L0.418025 3.4674C0.499814 2.73377 0.849213 2.05605 1.39938 1.56389C1.94954 1.07173 2.66185 0.799689 3.40002 0.799805H16.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1616_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9ee11638b881313b8f538a355bb28c26.svg";
export { ForwardRef as ReactComponent };